import { PermissionsData } from 'modules/authenticate/interfaces';

export const getHeaders = (permissions: PermissionsData | undefined) =>
  [
    {
      key: '',
      i18n: 'ACCESS_KEY',
      centerTitle: true,
      style: { width: 30, fontSize: 12 },
      hidden: !!permissions && !permissions.list_environment_instances,
    },
    {
      order: true,
      key: 'environment_name',
      i18n: 'ENVIRONMENT_NAME_KEY',
    },
    {
      order: true,
      key: 'partner_name',
      i18n: 'OPERATOR_VIEW_PARTNER_NAME_KEY',
    },
    {
      order: true,
      key: 'num_clients',
      i18n: 'CLIENTS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'num_users',
      i18n: 'USERS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'license_limit',
      i18n: 'LICENSES_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'operational_instances_count',
      i18n: 'INSTANCES_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'sessions_count',
      i18n: 'SESSIONS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'user_last_access',
      i18n: 'LAST_ACCESS_SINGULAR_KEY',
      centerTitle: true,
      textAlignCenter: true,
    },
    {
      key: '',
      i18n: 'ACTIONS_KEY',
      centerTitle: true,
      style: { width: 30, fontSize: 12 },
    },
  ].filter(item => !item.hidden);
